export default __webpack_public_path__ + "static/media/shipment.10128436.svg";